// extracted by mini-css-extract-plugin
export default {"container":"_1pXV","label":"_1yPa"};